import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function HelpCircleFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM11 16.5C11 15.9477 11.4477 15.5 12 15.5H12.009C12.5613 15.5 13.009 15.9477 13.009 16.5C13.009 17.0523 12.5613 17.5 12.009 17.5H12C11.4477 17.5 11 17.0523 11 16.5ZM11 9.5C11 8.94772 11.4477 8.5 12 8.5C12.5523 8.5 13 8.94772 13 9.5C13 9.70057 12.942 9.88454 12.8422 10.0397C12.7241 10.2232 12.5739 10.4167 12.3889 10.6466L12.2993 10.7576C12.1441 10.9494 11.9687 11.1665 11.8088 11.3862C11.4328 11.903 11 12.6184 11 13.5C11 14.0523 11.4477 14.5 12 14.5C12.5523 14.5 13 14.0523 13 13.5C13 13.277 13.1099 12.9973 13.426 12.5629C13.5532 12.3881 13.6904 12.2182 13.8449 12.027L13.9471 11.9004C14.1337 11.6684 14.3433 11.4028 14.5241 11.1219C14.8253 10.6537 15 10.0957 15 9.5C15 7.84315 13.6569 6.5 12 6.5C10.3431 6.5 9 7.84315 9 9.5C9 10.0523 9.44771 10.5 10 10.5C10.5523 10.5 11 10.0523 11 9.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

HelpCircleFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default HelpCircleFilledIcon;
